var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_WeakMap.js
// module id = 671
// module chunks = 0 1 2 3 4 5 6 7 8